const SUPPORTS_CRYPTO_RANDOM_UUID = typeof crypto !== "undefined" && typeof crypto.randomUUID === "function";

const supportsCryptoRandomValues = typeof crypto !== "undefined" && typeof crypto.getRandomValues === "function";

const generateRandomHex = (length: number): string => {
  if (supportsCryptoRandomValues) {
    const bytes = new Uint8Array(length);
    crypto.getRandomValues(bytes);
    return Array.from(bytes, (byte) => byte.toString(16).padStart(2, "0")).join("");
  }

  let output = "";
  while (output.length < length * 2) {
    output += Math.random().toString(16).slice(2);
  }
  return output.slice(0, length * 2);
};

const generateId = (): string => {
  if (SUPPORTS_CRYPTO_RANDOM_UUID) {
    try {
      return crypto.randomUUID();
    } catch {
      // Fall back to manual generation below
    }
  }

  const timestamp = Date.now().toString(36);
  const entropy = generateRandomHex(8);
  return `cid_${timestamp}_${entropy}`;
};

/** A fresh id for each request, queued event, or browser observation. */
export const createRequestCorrelationId = (): string => generateId();
